<template>
  <div>
    <b-overlay
      class="lp-container"
      :show="loading"
      variant="transparent"
      rounded="sm"
    >
      <carousel
        v-if="activeStep === 1"
        ref="bohoSlider"
        :pagination-enabled="true"
        :per-page="1"
        :loop="true"
        :autoplay="false"
        class="d-flex align-items-end justify-content-center w-100 lp-content"
        @pageChange="onPageChange"
      >
        <slide
          v-for="(cardUser, index) in cardUsers"
          :key="index"
        >
          <LpUserCard
            custom-class="lp-content"
            :user="cardUser"
            @nextCarousel="nextCarousel"
            @updateActiveStep="activeStep = $event"
          />
        </slide>
        <slide>
          <LpFinalCard
            @nextCarousel="nextCarousel"
            @updateActiveStep="activeStep = $event"
          />
        </slide>
        <slide />
      </carousel>
      <transition name="slide">
        <div
          v-if="loginToken && activeStep === 2"
          class="lp-content lp-login"
        >
          <lp-products
            :loading="loading"
            :products="products"
            :selected-product="selectedProduct"
            show-login-url
            @updateActiveStep="activeStep = $event"
            @updateSelectedProduct="selectedProduct = $event"
          />
        </div>
      </transition>
      <transition name="slide">
        <div
          v-if="selectedProduct && activeStep === 3"
          class="lp-content"
        >
          <lp-payment
            :loading="loading"
            :selected-product="selectedProduct"
            @setLoading="loading = $event"
          />
        </div>
      </transition>
    </b-overlay>
  </div>
</template>

<script>
import LpFinalCard from '@/components/Lp/LpFinalCard.vue'
import LpPayment from '@/components/Lp/LpPayment.vue'
import LpProducts from '@/components/Lp/LpProducts.vue'
import LpUserCard from '@/components/Lp/LpUserCard.vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Carousel, Slide } from 'vue-carousel'
import {
  BOverlay,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import {
  numberFormat,
  throwDefaultError,
} from '@/helpers/helpers'
import { localeChanged, localize } from 'vee-validate'

const avatarEsma = require('@/assets/images/lps/esma.jpg')
const avatarHakan = require('@/assets/images/lps/hakan.jpg')
const avatarSasha = require('@/assets/images/lps/sasha.jpg')

export default {
  name: 'Lp2',
  components: {
    LpPayment,
    BOverlay,
    Carousel,
    LpFinalCard,
    LpProducts,
    LpUserCard,
    Slide,
  },
  data() {
    return {
      activeStep: 1,
      cardUsers: [
        {
          age: 26,
          bio: this.$t('lps.userCard1.bio'),
          headerSlogan: this.$t('lps.userCard1.headerSlogan'),
          headerSubSlogan: this.$t('lps.userCard1.headerSubSlogan'),
          image: avatarEsma,
          name: 'Esma',
        },
        {
          age: 27,
          bio: this.$t('lps.userCard2.bio'),
          headerSlogan: this.$t('lps.userCard2.headerSlogan'),
          headerSubSlogan: this.$t('lps.userCard2.headerSubSlogan'),
          image: avatarHakan,
          name: 'Hakan',
        },
        {
          age: 30,
          bio: this.$t('lps.userCard3.bio'),
          headerSlogan: this.$t('lps.userCard3.headerSlogan'),
          headerSubSlogan: this.$t('lps.userCard3.headerSubSlogan'),
          image: avatarSasha,
          name: 'Sasha',
        },
      ],
      loading: false,
      loginToken: null,
      lpProducts: [
        {
          id: 'com.arasana.app.10DKl',
          name: '',
        },
        {
          id: 'com.arasana.app.25DKl',
          name: this.$t('lps.product.MOST POPULAR'),
          discount: 40,
          popular: true,
        },
        {
          id: 'com.arasana.app.50DKl',
          name: this.$t('lps.product.Best Value'),
        },
      ],
      products: [],
      selectedProduct: null,
      purchaseSource: 'lp1',
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/user']
    },
  },
  watch: {
    activeStep(value) {
      if (value === 2) {
        if (this.user) {
          this.$router.push('/')
        } else {
          this.lpUserAction('choose-product', false)
        }
      } else if (value === 3) {
        this.lpUserAction('buy-product', false)
      }
    },
  },
  created() {
    this.getProducts()

    this.lpUserAction()

    localStorage.setItem('try_route_name', 'lp2')

    localize(this.$i18n.locale)
    localeChanged()

    if (this.user) {
      this.$router.push('/')
    }
  },
  mounted() {
    setInterval(() => {
      // this.a += 1

      if (this.a > 4) {
        this.a = 1
      }
    }, 3000)
  },
  methods: {
    numberFormat,
    getProducts() {
      useJwt.getLandingProducts()
        .then(response => {
          const products = response.data.body || []

          this.products = this.lpProducts.map(p => {
            const product = {
              ...p,
              product: products.find(p2 => p2.productId === p.id),
            }

            if (p.popular) {
              this.selectedProduct = {
                ...product,
              }
            }

            return product
          }).filter(p2 => !!p2.product)
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    lpUserAction(action = 'new-user', showLoading = true) {
      if (showLoading) {
        this.loading = true
      }

      const query = this.$route.query || {}
      const data = {
        flow: 'lp-2',
        action,
        data: JSON.stringify({ query }),
        deviceId: this.$store.getters['app/deviceId'],
      }

      useJwt.lpUserAction(data)
        .then(response => {
          localStorage.setItem('tempLoginToken', response.data.body.loginToken)
          this.loginToken = response.data.body.loginToken
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .finally(() => {
          if (showLoading) {
            this.loading = false
          }
        })
    },
    nextCarousel() {
      if (this.$refs.bohoSlider) {
        this.$refs.bohoSlider.goToPage(this.$refs.bohoSlider.getNextPage())
      }
    },
    onPageChange(currentPage) {
      if (currentPage === 4) {
        this.activeStep = 2
      } else if (currentPage !== 0) {
        this.lpUserAction(`step-${currentPage + 1}`, false)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.vs__dropdown-toggle {
  padding: 8px 4px !important;
  border-radius: 12px !important;
}
</style>

<style lang="scss" scoped>
.slide-leave-active,
.slide-enter-active {
  transition: 0.4s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}
input {
  padding: 24px 16px !important;
  border-radius: 12px !important;
}
</style>
